import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import NewGroupBtn from './NewGroupBtn'
import ContactsListItem from './ContactsListItem'
import {inject, observer} from "mobx-react";

@inject('contactsStore') @observer
class ContactsList extends React.Component {
  
  render(){
    return(
      <div className="contacts-list">
        <div>
          { this.props.showNewGroupBtn && <NewGroupBtn /> }   
          { this.props.contactsStore.contacts.map( (contact) => 
              <ContactsListItem 
                contact={contact}
                onClick={this.props.onContactClick}
                key={contact.id}
              />
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(ContactsList);